import { render, staticRenderFns } from "./StatusCircleIcon.vue?vue&type=template&id=5cbbb52a&scoped=true"
import script from "./StatusCircleIcon.vue?vue&type=script&lang=js"
export * from "./StatusCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbbb52a",
  null
  
)

export default component.exports